var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React from 'react';
import PropTypes from 'prop-types';
import ScalerContext from '../../context/Scaler';
import { createYScale, createXScale } from '../../utils/scale-helpers';
import Points from '../Points';
import GriffPropTypes, { seriesPropType } from '../../utils/proptypes';
import Axes from '../../utils/Axes';
var propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  series: seriesPropType.isRequired,
  subDomainsByItemId: GriffPropTypes.subDomainsByItemId.isRequired
};
var defaultProps = {};

var PointCollection = function PointCollection(_ref) {
  var width = _ref.width,
      height = _ref.height,
      series = _ref.series,
      subDomainsByItemId = _ref.subDomainsByItemId;
  var points = series.filter(function (s) {
    return !s.hidden && s.drawPoints !== false;
  }).map(function (s) {
    // TODO: We can't use [s.collectionId || s.id] on the x axis. I'm not
    // entirely sure why; I think it's because the collection's x domain is not
    // correctly calculated to the data's extent. I have not looked into it
    // because it doesn't really matter yet, but it will at some point.
    var xScale = createXScale(Axes.x(subDomainsByItemId[s.id]), width);
    var yScale = createYScale(Axes.y(subDomainsByItemId[s.collectionId || s.id]), height); // Only show points which are relevant for the current time subdomain.
    // We don't need to do this for lines because we want lines to be drawn to
    // infinity so that they go to the ends of the graph, but points are special
    // since they can overlap in the [x,y] plane, but not be in the current time
    // subdomain.

    var pointFilter = function pointFilter(d) {
      var timestamp = s.timeAccessor(d);
      var subDomain = Axes.time(subDomainsByItemId[s.id]);
      return subDomain[0] <= timestamp && timestamp <= subDomain[1];
    };

    return React.createElement(Points, _extends({
      key: s.id
    }, s, {
      xScale: xScale,
      yScale: yScale,
      pointFilter: pointFilter
    }));
  });
  return React.createElement('g', {
    width: width,
    height: height
  }, React.createElement('clipPath', {
    id: 'scatterplot-clip-path-' + series.map(function (s) {
      return s.id;
    }).join('-')
  }, React.createElement('rect', {
    width: width,
    height: height,
    fill: 'none'
  })), points);
};

PointCollection.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
PointCollection.defaultProps = defaultProps;
export default (function (props) {
  return React.createElement(ScalerContext.Consumer, null, function (_ref2) {
    var subDomainsByItemId = _ref2.subDomainsByItemId,
        series = _ref2.series;
    return React.createElement(PointCollection, _extends({}, props, {
      series: series,
      subDomainsByItemId: subDomainsByItemId
    }));
  });
});